import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Tag extends Model {
    static entity = 'tags';

    static queryBuilder() {
        return new QueryBuilder(this.entity);
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            slug: this.attr(''),
            type: this.string(''),
            order_column: this.number(1),

            created_at: this.string(''),
            updated_at: this.string(''),
        };
    }

    static async fetch(endpoint = null) {
        const { response } = await this.api().get(endpoint || this.queryBuilder().toUrl());

        return response.data;
    }
}
